/**
 * 滚动控制 Mixin
 * 负责管理滚动相关的逻辑和"滚动到底部"按钮
 */
export default {
  data() {
    return {
      showScrollToBottom: false,
    };
  },

  methods: {
    /**
     * 滚动到底部
     */
    scrollToBottom() {
      const container = this.$refs.scrollContainer;
      if (container) {
        container.scrollTo({
          top: container.scrollHeight,
          behavior: 'smooth'
        });
      }
    },

    /**
     * 判断是否接近底部
     * @param {number} threshold - 距离阈值（默认 100px）
     * @returns {boolean} 是否接近底部
     */
    isNearBottom(threshold = 100) {
      const container = this.$refs.scrollContainer;
      if (!container) return true;

      const scrollTop = container.scrollTop;
      const scrollHeight = container.scrollHeight;
      const clientHeight = container.clientHeight;
      const distanceToBottom = scrollHeight - scrollTop - clientHeight;

      // 距离底部小于阈值时，认为在底部附近
      return distanceToBottom <= threshold;
    },

    /**
     * 处理滚动事件
     */
    handleScroll() {
      const container = this.$refs.scrollContainer;
      if (!container) return;

      const scrollTop = container.scrollTop;
      const scrollHeight = container.scrollHeight;
      const clientHeight = container.clientHeight;
      const distanceToBottom = scrollHeight - scrollTop - clientHeight;

      // 距离底部超过 100px 时显示按钮
      this.showScrollToBottom = distanceToBottom > 100;
    },
  },

  mounted() {
    // 初始化时检查是否需要显示滚动按钮
    this.$nextTick(() => {
      this.handleScroll();
    });
  },
};
